/**
 * Canonicalizes raw GEDCOM place strings before cache lookups.
 *
 * Without normalization, "Somerset, PA" and "Somerset,PA" and " Somerset, PA "
 * would cache as three separate keys. The ~500 unique place strings in a
 * typical GEDCOM can expand to >1500 variations without this step.
 */
export class LocationNormalizer {
  /**
   * Returns the canonical form of a place name, or null for blank input.
   *
   * Rules applied in order:
   * 1. Trim leading/trailing whitespace
   * 2. Return null if result is empty
   * 3. Collapse internal whitespace (tabs, multiple spaces → single space)
   * 4. Lowercase
   * 5. Normalize commas: exactly one space after, none before; strip trailing comma
   * 6. Strip diacritics (NFD decompose → remove combining marks)
   */
  normalize(raw: string): string | null {
    let s = raw.trim();
    if (s.length === 0) return null;

    s = s.replace(/\s+/g, ' ');
    s = s.toLowerCase();
    s = s.replace(/\s*,\s*/g, ', ');
    s = s.replace(/,\s*$/, '').trim();
    s = s.normalize('NFD').replace(/\p{M}/gu, '');

    return s.length === 0 ? null : s;
  }
}
